import { api } from "@/api";
import { SearchResultItem } from "@/types/domain";
import { AnalysisValue, AnalysisType } from "@/types/domain";

type RedirectUrlResponse = {
  url: string;
};

export const searchAutocomplete = async (
  searchQuery: string,
  category: string,
  categoryName: string
): Promise<SearchResultItem[]> => {
  const res = await api.post<SearchResultItem[]>("/autocomplete/search", {
    searchQuery,
    category,
    categoryName,
  });
  return res.data ?? [];
};

export const getRedirectUrl = async (
  id: string,
  target: string,
  data: string
): Promise<string | null> => {
  const res = await api.post<RedirectUrlResponse>("/autocomplete/redirecturl", { id, target, data });
  return res.data?.url ?? null;
};

export const getRedirectUrlMultiselect = async (
  ids: string[],
  target: string,
  data: string
): Promise<string | null> => {
  const res = await api.post<RedirectUrlResponse>("/autocomplete/redirecturlmultiselect", { ids, target, data });
  return res.data?.url ?? null;
};

export const findForMultipleCompanies = async (
  searchQuery: string
): Promise<Array<{ id: string; label: string }>> => {
  const res = await api.get<Array<{ id: string; label: string }>>(
    "/autocomplete/FindForMultipleCompanies",
    { params: { searchQuery } }
  );
  return res.data ?? [];
};

export const searchAnalysisValues = async (
  index: number,
  search: string,
  analysisType: AnalysisType
): Promise<AnalysisValue[]> => {
  const res = await api.get<AnalysisValue[]>("/autocomplete/analysis-values", {
    params: { index, search, analysisType },
  });
  return res.data ?? [];
};

export const searchContactUdLookup = async (itemId: number, search: string): Promise<string[]> => {
  const response = await api.get<string[]>("/autocomplete/FindForContactUdLookup", { params: { itemId, searchQuery: search } });
  return response.data;
};

export const searchProspectUdLookup = async (itemId: number, search: string): Promise<string[]> => {
  const response = await api.get<string[]>("/autocomplete/FindForProspectUdLookup", { params: { itemId, searchQuery: search } });
  return response.data;
};

export const searchUsers = async (search: string): Promise<Array<{ id: string; label: string }>> => {
  const res = await api.get<Array<{ id: string; label: string }>>("/autocomplete/users", { params: { search } });
  return res.data ?? [];
};